import { defineStore } from 'pinia';
import config from '@/config';

export type PreloaderVariant = 'A' | 'A+';

export const useCustomizerStore = defineStore({
    id: 'customizer',
    state: () => ({
        Sidebar_drawer: config.Sidebar_drawer,
        Customizer_drawer: config.Customizer_drawer,
        mini_sidebar: config.mini_sidebar,
        setHorizontalLayout: config.setHorizontalLayout, // Horizontal layout
        setRTLLayout: config.setRTLLayout, // RTL layout
        actTheme: config.actTheme,
        boxed: config.boxed,
        setBorderCard: config.setBorderCard,
        preloader: config.preloader,
        // Which preloader plays the next time `preloader` goes true (design system
        // v3.3): 'A' below the main navigation for a module change or a page's
        // own load, 'A+' full screen for log in / log out / switching organisation.
        // Preloader.vue resets it to 'A' once an 'A+' has finished, so callers
        // that only ever flip `preloader` keep getting the default.
        preloaderVariant: 'A' as PreloaderVariant
    }),

    getters: {},
    actions: {
        SET_PRELOADER() {
            this.preloader = !this.preloader;
        },
        /** Show the preloader with a given variant. Same flag every caller uses. */
        SHOW_PRELOADER(variant: PreloaderVariant = 'A') {
            this.preloaderVariant = variant;
            this.preloader = true;
        },
        SET_SIDEBAR_DRAWER() {
            this.Sidebar_drawer = !this.Sidebar_drawer;
        },
        SET_MINI_SIDEBAR(payload: any) {
            this.mini_sidebar = payload;
        },
        SET_CUSTOMIZER_DRAWER(payload: any) {
            this.Customizer_drawer = payload;
        },

        SET_LAYOUT(payload: any) {
            this.setHorizontalLayout = payload;
        },
        SET_THEME(payload: any) {
            this.actTheme = payload;
        },
        SET_CARD_BORDER(payload: any) {
            this.setBorderCard = payload;
        }
    }
});
